module.exports = __webpack_public_path__ + "static/img/team_brand@3x.f619ccf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team_brand@3x.png
// module id = BAvA
// module chunks = 1